import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
var _excluded = ["tag", "className", "style", "scaleIndent", "display", "boxSizing", "inline", "flex", "w", "h", "wMin", "wMax", "hMin", "hMax", "m", "mt", "mb", "my", "ml", "mr", "mx", "p", "pt", "pb", "py", "pl", "pr", "px", "css", "position", "top", "left", "bottom", "right", "zIndex"];
import React from 'react';
import cn from 'classnames';
import { sstyled } from 'intergalactic/core';
import propsForElement from 'intergalactic/utils/lib/propsForElement';
import logger from 'intergalactic/utils/lib/logger';
/*__reshadow-styles__:"../style/use-box.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SBoxSizing_cv2w1_gg_{box-sizing:border-box}.___SBoxInline_cv2w1_gg_{display:inline-block}" /*__inner_css_end__*/, "cv2w1_gg_") /*__reshadow_css_end__*/, {
  "__SBoxSizing": "___SBoxSizing_cv2w1_gg_",
  "__SBoxInline": "___SBoxInline_cv2w1_gg_"
});
import { getAutoOrScaleIndent } from '../utils';
export function removeUndefinedKeys(obj) {
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
function getSize(size) {
  if (typeof size !== 'number') {
    return size;
  }
  if (size < 1) {
    return "".concat(100 * size, "%");
  }
  if (size >= 1) {
    return "".concat(size, "px");
  }
}
function calculateIndentStyles(props, scaleIndent) {
  return removeUndefinedKeys({
    display: props['display'],
    width: getSize(props['w']),
    height: getSize(props['h']),
    minWidth: getSize(props['wMin']),
    maxWidth: getSize(props['wMax']),
    minHeight: getSize(props['hMin']),
    maxHeight: getSize(props['hMax']),
    position: props['position'],
    top: getSize(props['top']),
    left: getSize(props['left']),
    bottom: getSize(props['bottom']),
    right: getSize(props['right']),
    flex: props.flex,
    zIndex: props.zIndex,
    margin: getAutoOrScaleIndent(props['m'], scaleIndent),
    marginTop: getAutoOrScaleIndent(props['mt'], scaleIndent) || getAutoOrScaleIndent(props['my'], scaleIndent),
    marginBottom: getAutoOrScaleIndent(props['mb'], scaleIndent) || getAutoOrScaleIndent(props['my'], scaleIndent),
    marginLeft: getAutoOrScaleIndent(props['ml'], scaleIndent) || getAutoOrScaleIndent(props['mx'], scaleIndent),
    marginRight: getAutoOrScaleIndent(props['mr'], scaleIndent) || getAutoOrScaleIndent(props['mx'], scaleIndent),
    padding: getAutoOrScaleIndent(props['p'], scaleIndent),
    paddingTop: getAutoOrScaleIndent(props['pt'], scaleIndent) || getAutoOrScaleIndent(props['py'], scaleIndent),
    paddingBottom: getAutoOrScaleIndent(props['pb'], scaleIndent) || getAutoOrScaleIndent(props['py'], scaleIndent),
    paddingLeft: getAutoOrScaleIndent(props['pl'], scaleIndent) || getAutoOrScaleIndent(props['px'], scaleIndent),
    paddingRight: getAutoOrScaleIndent(props['pr'], scaleIndent) || getAutoOrScaleIndent(props['px'], scaleIndent)
  });
}
export default function useBox(props, ref) {
  var _ref3 = props,
    _ref3$tag = _ref3.tag,
    Tag = _ref3$tag === void 0 ? 'div' : _ref3$tag,
    className = _ref3.className,
    styleProp = _ref3.style,
    _ref3$scaleIndent = _ref3.scaleIndent,
    scaleIndent = _ref3$scaleIndent === void 0 ? 4 : _ref3$scaleIndent,
    display = _ref3.display,
    boxSizing = _ref3.boxSizing,
    inline = _ref3.inline,
    flex = _ref3.flex,
    w = _ref3.w,
    h = _ref3.h,
    wMin = _ref3.wMin,
    wMax = _ref3.wMax,
    hMin = _ref3.hMin,
    hMax = _ref3.hMax,
    m = _ref3.m,
    mt = _ref3.mt,
    mb = _ref3.mb,
    my = _ref3.my,
    ml = _ref3.ml,
    mr = _ref3.mr,
    mx = _ref3.mx,
    p = _ref3.p,
    pt = _ref3.pt,
    pb = _ref3.pb,
    py = _ref3.py,
    pl = _ref3.pl,
    pr = _ref3.pr,
    px = _ref3.px,
    css = _ref3.css,
    position = _ref3.position,
    top = _ref3.top,
    left = _ref3.left,
    bottom = _ref3.bottom,
    right = _ref3.right,
    zIndex = _ref3.zIndex,
    other = _objectWithoutProperties(_ref3, _excluded);
  var indentStyles = React.useMemo(function () {
    return calculateIndentStyles(props, scaleIndent);
  }, [scaleIndent, display, w, h, wMin, wMax, hMin, hMax, flex, m, mt, mb, my, ml, mr, mx, p, pt, pb, py, pl, pr, px, position, top, left, bottom, right, zIndex]);
  logger.warn(css !== undefined, "The 'css' property is deprecated, use 'style'", other['data-ui-name'] || 'Box');
  var styles = sstyled(style);
  if (Tag === React.Fragment) return [React.Fragment, {
    children: props.children
  }];
  return [Tag, _objectSpread({
    ref: ref,
    className: cn(styles.cn('SBox', {
      SBoxSizing: boxSizing,
      SBoxInline: inline
    }).className, className) || undefined,
    style: Object.assign({}, styleProp, css, indentStyles),
    'data-ui-name': 'Box'
  }, propsForElement(other, Tag))];
}
//# sourceMappingURL=useBox.js.map